import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import React from 'react'
import { NightlyLatestEdition } from './LatestEdition/NightlyLatestEdition'
import EditionPlaceholder from './EditionPlaceholder/EditionPlaceholder'

export interface NightlyLatestEditionRouteProps {
    title: string
    type: 'homepage' | 'editions'
    lazyloadImages?: boolean
}

export const NightlyLatestEditionRegistration =
    createRegisterableComponentWithData(
        'nightly-latest-edition',
        EditionLoader,
        (
            { type, title, lazyloadImages }: NightlyLatestEditionRouteProps,
            data,
        ) => {
            if (!data.loaded) return null
            if (!data.result || data.result.documents.length < 1) {
                return (
                    <EditionPlaceholder
                        type={type}
                        lazyloadImages={lazyloadImages}
                    />
                )
            }

            return (
                <NightlyLatestEdition
                    edition={data.result.documents[0]}
                    title={title}
                    type={type}
                    lazyloadImages={lazyloadImages}
                />
            )
        },
    )
